import { useAsertoApiWithAuth, v2Api } from '@aserto/console-common'

import { useConfig } from '../services/ConfigProvider'

export function useTenantsClient() {
  const { tenantServiceUrl } = useConfig()
  const tenantApi = `${v2Api(tenantServiceUrl)}`
  return useAsertoApiWithAuth(tenantApi)
}
